import { HTTP_STATUS } from 'constants/env';

export const getHttpStatus = error => error?.response?.status;

export const getValidationFieldErrors = (error, field) =>
    error?.response?.data?.data?.[field];

export const hasValidationFieldErrors = (error, field) => {
    const fieldErrors = getValidationFieldErrors(error, field);
    if (Array.isArray(fieldErrors)) {
        return fieldErrors.length > 0;
    }
    return Boolean(fieldErrors);
};

export const isInvalidPartnerShortId = error =>
    hasValidationFieldErrors(error, 'partner_short_id');

export const createStatusError = (status, extra = {}) => {
    const error = new Error(`HTTP ${status}`);
    error.status = status;
    Object.assign(error, extra);
    return error;
};

export const getThrownErrorStatus = error => Number(error?.status ?? error);

export const shouldSkipInitialLoaderDelay = (status, error) =>
    status === HTTP_STATUS.TOO_MANY_REQUESTS ||
    (status === HTTP_STATUS.UNPROCESSABLE_ENTITY &&
        Boolean(error?.isInvalidPartnerShortId));
